document.addEventListener("DOMContentLoaded", async function () {
    // atc
    document.querySelectorAll(".collectionItem[data-product-id]").forEach((product) => {
        product.querySelector(".collectionItemButton")?.addEventListener("click", async function () {
            // loading
            this.classList.add("loading");

            const id = parseInt(product.dataset.productId);

            // add to cart
            await addProduct({
                id: id,
                quantity: 1
            });

            // remove loading
            this.classList.remove("loading");

            // open cart
            await openCart();
        });
    })
});